import { getLocalizedNameByLocale } from '@mfw/components';
import { v4 as uuidv4 } from 'uuid';

import type {
  ApiConfigurable,
  UiConfigurable,
} from '../../schemas/configurables.schema';

export function mapConfigurableFromApi(
  apiConfigurable: ApiConfigurable,
): UiConfigurable {
  const { id, createdAt, format, isMandatory, key, type, unit, updatedAt } =
    apiConfigurable;
  return {
    id,
    createdAt,
    format,
    isMandatory,
    key,
    translations: apiConfigurable.translations.map((translation) => ({
      id: translation.id,
      locale: [
        {
          label: getLocalizedNameByLocale(translation.locale),
          value: translation.locale,
        },
      ],
      name: translation.name,
    })),
    type,
    uniqueId: uuidv4(),
    unit,
    updatedAt,
  };
}
